export const IconClock = (
    <g viewBox='0 0 18 18' fill='none'>
        <path
            d='M9 1C4.58891 1 1 4.58861 1 9C1 13.4114 4.58861 17 9 17C13.4114 17 17 13.4114 17 9C17 4.58861 13.4114 1 9 1ZM9 16.1899C5.03556 16.1899 1.81013 12.9644 1.81013 9C1.81013 5.03556 5.03556 1.81013 9 1.81013C12.9644 1.81013 16.1899 5.03556 16.1899 9C16.1899 12.9644 12.9644 16.1899 9 16.1899Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.5'
        />
        <path
            d='M9.40522 8.83216V4.45181C9.40522 4.22812 9.22392 4.04671 9.00022 4.04671C8.77652 4.04671 8.59521 4.22813 8.59521 4.45181V9.00003C8.59521 9.10752 8.63795 9.21053 8.71377 9.28646L10.9951 11.5679C11.0742 11.647 11.1779 11.6866 11.2815 11.6866C11.3853 11.6866 11.4889 11.647 11.5679 11.5679C11.7261 11.4097 11.7261 11.1533 11.568 10.9951L9.40522 8.83216Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.5'
        />
    </g>
);
